import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { KEY_CODES, KEY_DOWN } from '@outdoor-voices/ui/dist/config/constants';
import { searchArticles } from './queries';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { ROOT_URL, SUGGEST } from './constants';
import css from './Suggestions.module.scss';
import formCSS from './Form.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Results = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onClear = _ref.onClear,
      openInNewTab = _ref.openInNewTab,
      id = _ref.id,
      focusIndex = _ref.focusIndex,
      value = _ref.value;
  var history = useHistory();

  var _useQuery = useQuery({
    query: searchArticles,
    variables: {
      search: value
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  var articles = fetching ? [] : data.faqsArticles;
  var direction = articles.length > 0 ? ' Use the arrow keys to focus hit enter to navigate to the article.' : '';
  var plurality = articles.length === 1 ? '' : 's';
  var status = !fetching ? "".concat(articles.length, " suggested article").concat(plurality, ".").concat(direction) : 'Loading suggested articles.';

  var onLinkClick = function onLinkClick(event) {
    if (event.metaKey) {
      return;
    }

    event.preventDefault();

    if (onClear) {
      onClear();
    }

    window.dispatchEvent(new CustomEvent(SUGGEST, {
      detail: event.target.dataset.slug
    }));
    history.push(event.target.dataset.to);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      "aria-live": "polite",
      role: "status",
      className: "ada-hidden",
      children: status
    }), /*#__PURE__*/_jsx("div", {
      className: css.title,
      children: "Suggested articles:"
    }), /*#__PURE__*/_jsxs("ul", {
      className: css.list,
      id: id,
      ref: ref,
      role: "listbox",
      children: [fetching && /*#__PURE__*/_jsx(_Fragment, {
        children: new Array(6).fill().map(function (_, idx) {
          return /*#__PURE__*/_jsx("li", {
            "aria-busy": "true",
            className: css.item,
            children: /*#__PURE__*/_jsx("div", {
              className: css.loading,
              children: "\xA0"
            })
          }, idx);
        })
      }), !fetching && articles.length === 0 && /*#__PURE__*/_jsx("li", {
        className: css.item,
        children: /*#__PURE__*/_jsx("div", {
          className: css.noResults,
          children: "No articles"
        })
      }), !fetching && /*#__PURE__*/_jsx(_Fragment, {
        children: articles.map(function (_ref2, idx) {
          var articleId = _ref2.id,
              slug = _ref2.slug,
              title = _ref2.title,
              categorySlug = _ref2.categorySlug;
          var linkProps = openInNewTab ? {
            target: '_blank',
            rel: 'noopener noreferrer'
          } : {
            onClick: onLinkClick
          };
          return /*#__PURE__*/_jsx("li", {
            className: css.item,
            children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, linkProps), {}, {
              "aria-selected": idx === focusIndex,
              "data-slug": "#".concat(slug),
              "data-to": "".concat(ROOT_URL, "-").concat(categorySlug, "#").concat(slug),
              href: "".concat(ROOT_URL, "-").concat(categorySlug, "#").concat(slug),
              role: "option",
              tabIndex: "-1",
              children: title
            }))
          }, articleId);
        })
      })]
    })]
  });
});
Results.propTypes = {
  id: PropTypes.string,
  focusIndex: PropTypes.number,
  onClear: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  openInNewTab: PropTypes.bool,
  value: PropTypes.string
};

var Suggestions = function Suggestions(_ref3) {
  var _ref3$hideLabel = _ref3.hideLabel,
      hideLabel = _ref3$hideLabel === void 0 ? false : _ref3$hideLabel,
      _ref3$hint = _ref3.hint,
      hint = _ref3$hint === void 0 ? false : _ref3$hint,
      _ref3$icon = _ref3.icon,
      icon = _ref3$icon === void 0 ? false : _ref3$icon,
      id = _ref3.id,
      _ref3$inline = _ref3.inline,
      inline = _ref3$inline === void 0 ? false : _ref3$inline,
      label = _ref3.label,
      onChange = _ref3.onChange,
      _ref3$onClear = _ref3.onClear,
      onClear = _ref3$onClear === void 0 ? false : _ref3$onClear,
      _ref3$openInNewTab = _ref3.openInNewTab,
      openInNewTab = _ref3$openInNewTab === void 0 ? false : _ref3$openInNewTab,
      _ref3$placeholder = _ref3.placeholder,
      placeholder = _ref3$placeholder === void 0 ? '' : _ref3$placeholder,
      value = _ref3.value;

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      focusIndex = _useState2[0],
      setFocusIndex = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      inputFocused = _useState4[0],
      setInputFocused = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      on = _useState6[0],
      setOn = _useState6[1];

  var inputRef = useRef(null);
  var listRef = useRef(null);
  useEffect(function () {
    setOn(value.length > 0);
    setFocusIndex(-1);
  }, [value]);
  useEffect(function () {
    if (focusIndex < 0) {
      return;
    }

    var item = listRef.current.querySelector("li:nth-child(".concat(focusIndex + 1, ") a"));
    if (item) item.focus();
  }, [focusIndex]);
  useEffect(function () {
    if (!on) {
      return;
    }

    var onKeyDown = function onKeyDown(event) {
      switch (event.key) {
        case KEY_CODES.ARROW_DOWN:
          {
            event.preventDefault();
            var items = listRef.current.querySelectorAll('li a');
            setFocusIndex(Math.min(focusIndex + 1, items.length - 1));
            break;
          }

        case KEY_CODES.ARROW_UP:
          event.preventDefault();

          if (on && focusIndex === 0) {
            inputRef.current.focus();
            setOn(false);
          }

          setFocusIndex(Math.max(focusIndex - 1, -1));
          break;

        case KEY_CODES.TAB:
          setOn(false);
          break;

        case KEY_CODES.ESC:
          inputRef.current.focus();
          setOn(false);
          break;
      }
    };

    document.addEventListener(KEY_DOWN, onKeyDown);
    return function () {
      document.removeEventListener(KEY_DOWN, onKeyDown);
    };
  }, [on, value, focusIndex]); // The input event listeners

  useEffect(function () {
    if (!inputFocused) {
      return;
    }

    var input = inputRef.current;

    var onKeyDown = function onKeyDown(event) {
      switch (event.key) {
        case KEY_CODES.ARROW_DOWN:
          if (!on) {
            setOn(value.length > 0);
          }

          break;
      }
    };

    input.addEventListener(KEY_DOWN, onKeyDown);
    return function () {
      input.removeEventListener(KEY_DOWN, onKeyDown);
    };
  }, [inputFocused, on, value]);
  useEffect(function () {
    if (!on) {
      return;
    }

    var close = function close() {
      setOn(false);
    };

    document.addEventListener('click', close);
    return function () {
      document.removeEventListener('click', close);
    };
  }, [on]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("label", {
      className: cc([css.label, _defineProperty({}, css.inline, inline)]),
      htmlFor: "".concat(id, "-input"),
      children: [icon && icon, /*#__PURE__*/_jsx("div", {
        className: cc([formCSS.label, _defineProperty({}, 'ada-hidden', hideLabel)]),
        children: label
      }), hint && /*#__PURE__*/_jsx("div", {
        className: formCSS.hint,
        dangerouslySetInnerHTML: {
          __html: hint
        }
      }), /*#__PURE__*/_jsx("input", {
        "aria-autocomplete": "list",
        "aria-controls": "suggestions",
        "aria-expanded": on,
        "aria-owns": "suggestions",
        autoCapitalize: "none",
        autoComplete: "off",
        className: cc([formCSS.input, _defineProperty({}, css.inputInline, inline)]),
        id: "".concat(id, "-input"),
        name: id,
        onBlur: function onBlur() {
          return setInputFocused(false);
        },
        onChange: onChange,
        onFocus: function onFocus() {
          return setInputFocused(true);
        },
        placeholder: placeholder,
        ref: inputRef,
        required: true,
        role: "combobox",
        value: value
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.options, _defineProperty({}, css.on, on)]),
      children: value.length > 0 && /*#__PURE__*/_jsx(Results, {
        id: id,
        ref: listRef,
        focusIndex: focusIndex,
        onClear: onClear,
        openInNewTab: openInNewTab,
        value: value
      })
    })]
  });
};

Suggestions.propTypes = {
  hideLabel: PropTypes.bool,
  hint: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  icon: PropTypes.any,
  id: PropTypes.string,
  inline: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onClear: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  openInNewTab: PropTypes.bool,
  placeholder: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  value: PropTypes.string
};
export default Suggestions;